import { snapshotApi } from '../api/snaphot';
import { TypedRootState } from '../types';

export const selectSnapshots = (state: TypedRootState, volumeId: string) =>
  snapshotApi.endpoints.getAllSnapshots.select(volumeId)(state)?.data;
export const selectedSnapshotId = (state: TypedRootState) =>
  state.snapshots.selectedSnapshotId;
